// src/component/CalendarContent.jsx

// 日历组件

// 系统库
import React from 'react'
import { CustomProvider, Calendar } from 'rsuite';
import 'rsuite/Calendar/styles/index.css';
import zhCN from 'rsuite/locales/zh_CN';
import enUS from 'rsuite/locales/en_US';

// 自定义库
import { Global } from '../services/Global'
import { browserUtil } from '../utils/BrowserUtil'
import { timeUtil } from '../utils/TimeUtil';
import { TaskRequestMonthRecords } from '../task/TaskRequestMonthRecords';

export default class CalendarContent extends React.Component {
    state = {
        year: 0,
        month: 0,
        recordMap: {},
    }

    task = null

    componentWillMount() {
        Global.isMobile = browserUtil.checkMobile()
    }

    componentDidMount = () => {
        const today = new Date()
        const year = timeUtil.getYeaerFromDate(today)
        const month = timeUtil.getMonthFromDate(today)
        this.setState({
            year: year,
            month: month,
        })
        this.requestRecords(year, month)
    }

    /** 请求记录数据 */
    requestRecords = async (year, month) => {
        const DEBUG = false
        const TAG = `CalendarContent.requestRecords() - `

        // 请求前先清空
        this.setState({ recordMap: {} })
        // 切换月份时先把上一个任务停止
        if(this.task) {
            DEBUG && console.log(TAG, `停止前一个任务`)
            DEBUG && console.time(`耗时`)
            await this.task.stop()
            DEBUG && console.timeEnd(`耗时`)
            this.task = null
        }

        // 开始一个新的任务
        this.task = new TaskRequestMonthRecords()
        this.task.year = year
        this.task.month = month
        this.task.setRecordMap = (map) => {
            this.setState({ recordMap: map })
        }
        this.task.start()
    }

    render() {
        if (Global.isMobile) return this.renderMobile()
        else return this.renderPc()
    }

    renderMobile() {
        let t = this.props.trans
        let i18n = this.props.i18n
        let lang = this.getLang(i18n.language)

        return (
            <section role="main" className="content-body">
                <header className="page-header">
                    <h2>{t('calendar')}</h2>
                </header>

                <div className="row">
                    {/** 日历组件 */}
                    <CustomProvider locale={lang}>
                        <Calendar bordered
                            renderCell={this.renderCell}
                            onChange={this.onChange}
                            onSelect={this.onSelect}
                        />
                    </CustomProvider>
                </div>
            </section>
        )
    }

    renderPc() {
        let t = this.props.trans
        let i18n = this.props.i18n
        let lang = this.getLang(i18n.language)

        return (
            <section role="main" className="content-body">
                <header className="page-header">
                    <h2>{t('calendar')}</h2>
                </header>

                <div className="row">
                    {/** 日历组件 */}
                    <CustomProvider locale={lang}>
                        <Calendar bordered
                            renderCell={this.renderCell}
                            onChange={this.onChange}
                            onSelect={this.onSelect}
                        />
                    </CustomProvider>
                </div>
            </section>
        )
    }

    getLang(lang) {
        switch (lang) {
            case 'zh_CN':
                return zhCN
            default:
                return enUS
        }
    }

    getRecordList = (date) => {
        const emptyRecord = {
            count: 0,
            recordList: []
        }
        const year = timeUtil.getYeaerFromDate(date)
        const month = timeUtil.getMonthFromDate(date)
        if (year != this.state.year || month != this.state.month) {
            return emptyRecord
        }
        const day = timeUtil.getDayFromDate(date)
        
        let recordMap = this.state.recordMap
        if (recordMap.get) {
            let recordOfDay = recordMap.get(day)
            if (recordOfDay) {
                // console.log(`${day}:\n`, recordOfDay)
                return recordOfDay
            }
            else {
                return emptyRecord
            }
        }
        else {
            return emptyRecord
        }
    }

    /**
     * 自定义渲染日期单元格的回调
     * @param {*} date 
     * @returns 
     */
    renderCell = (date) => {
        const list = this.getRecordList(date);

        const displayList = list.recordList.filter((item, index) => index < 3);

        if (list.count > 0) {
            return (
                <div style={{ textAlign: "left" }}>
                    {displayList.map((item, index) => (
                        <div>{item.age} <b>{item.time} - <font color={item.gendar == 1 ? "blue" : "red"}>{item.name.substring(0, 5)}</font></b></div>
                    ))}
                </div>
            );
        }
    }

    /**
     * 自定义日期变化回调
     * @param {*} date 
     */
    onChange = (date) => {
        // console.log(`onChange:`, date)
        let year = timeUtil.getYeaerFromDate(date)
        let month = timeUtil.getMonthFromDate(date)
        // console.log(`year:`, year)
        // console.log(`month:`, month)
        if (year != this.state.year || month != this.state.month) {
            this.setState({
                year: year,
                month: month,
            })
            this.requestRecords(year, month)
        }
        else {
            console.log(`仅切换日期，无需重复请求数据...`)
        }
    }

    /**
     * 自定义日期选择回调
     * @param {*} date 
     */
    onSelect = (date) => {
        console.log(`onSelect:`, date)
    }
}